document.addEventListener('DOMContentLoaded', function () {
  initializeSliders();
});

document.addEventListener('relatedProductsLoaded', function () {
  initializeSliders();
});

function initializeSliders() {
  document.querySelectorAll('.slider-section').forEach((slider, index) => {
    const deskCol = slider.getAttribute('data-desk-col') === 'auto' ? 'auto' : parseInt(slider.getAttribute('data-desk-col'), 10);
    const mobileCol = slider.getAttribute('data-mobile-col') === 'auto' ? 'auto' : parseFloat(slider.getAttribute('data-mobile-col'));
    const gap = parseInt(slider.getAttribute('data-gap'), 10);
    const autoplay = slider.getAttribute('data-autoplay') === 'true';
    const loop = slider.getAttribute('data-loop') === 'true';
    const parent = slider.parentElement;
    const nextButton = parent.querySelector('.swiper-button-next');
    const prevButton = parent.querySelector('.swiper-button-prev');
    const scrollbar = parent.querySelector('.swiper-scrollbar');
    
    new Swiper(slider, {
      slidesPerView: mobileCol,
      spaceBetween: gap,
      loop: loop,
      autoplay: autoplay ? { delay: 3000, disableOnInteraction: false } : false,
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
      scrollbar: {
        el: scrollbar,
        hide: true,
      },
      freeMode: true,
      grabCursor: true,
      breakpoints: {
        768: {
          slidesPerView: deskCol,
        },
      },
    });
  });
}
